import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=9997ff02&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9997ff02')) {
      api.createRecord('9997ff02', component.options)
    } else {
      api.reload('9997ff02', component.options)
    }
    module.hot.accept("./Role.vue?vue&type=template&id=9997ff02&", function () {
      api.rerender('9997ff02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Role.vue"
export default component.exports